module.exports = __webpack_public_path__ + "img/Warehouse04.8dd662bb.jpg";